import { nilConfig } from './collectionConfigs/nilConfig.js';
import { internationalConfig } from './collectionConfigs/internationalConfig.js';
export const collection = {
    type: '',
    region: '',
    language: '',
    fpAttributes: [],
    get schema() {
        if (this.type === 'international') {
            internationalConfig.fpAttributes = this.fpAttributes;
            return internationalConfig.schema;
        }
        if (this.type === 'nil') {
            return nilConfig;
        }
        return {};
    },
};
//# sourceMappingURL=collectionJsonEditorConfig.js.map